class FdShopNav extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const {signal} = this.controller;
    this.games = [...this.querySelectorAll('.fd-game-nav')];
    const on = (el, type, handler) => el.addEventListener(type, handler, {signal});
    this.querySelectorAll('.fd-menu-close').forEach(button => {
      button.hidden = false;
      on(button, 'click', () => this.close(true));
    });
    for (const details of this.games) {
      const summary = details.querySelector('summary');
      on(summary, 'pointerenter', event => {
        this.clearTimers();
        if (event.pointerType !== 'touch' && matchMedia('(hover:hover)').matches) {
          this.openTimer = setTimeout(() => this.open(details), 90);
        }
      });
      on(summary, 'pointerleave', () => clearTimeout(this.openTimer));
      on(summary, 'click', event => {
        // Keep a menu opened by pointer intent open on the subsequent mouse click.
        // Keyboard and touch clicks still toggle the native disclosure.
        if (event.detail && event.pointerType === 'mouse' && details.open) event.preventDefault();
      });
      on(summary, 'keydown', event => {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        this.open(details);
        (details.querySelector('.fd-menu-column a') || details.querySelector('.fd-menu-all'))?.focus({preventScroll:true});
      });
      on(details, 'toggle', () => {
        if (details.open) this.open(details);
        else summary.setAttribute('aria-expanded', 'false');
      });
      summary.setAttribute('aria-expanded', String(details.open));
    }
    this.querySelectorAll('.fd-main-nav > a').forEach(link => {
      on(link, 'pointerenter', event => {if (event.pointerType !== 'touch') this.close();});
      on(link, 'focus', () => this.close());
    });
    on(this, 'pointerenter', () => clearTimeout(this.closeTimer));
    on(this, 'pointerleave', event => {
      clearTimeout(this.openTimer);
      if (event.pointerType === 'touch') return;
      this.closeTimer = setTimeout(() => {
        if (!this.querySelector(':focus-visible')) this.close();
      }, 260);
    });
    on(this, 'focusout', event => {
      if (this.contains(event.relatedTarget)) return;
      clearTimeout(this.focusTimer);
      this.focusTimer = setTimeout(() => {if (!this.contains(document.activeElement)) this.close();}, 0);
    });
    on(document, 'pointerdown', event => {if (!this.contains(event.target)) this.close();});
    on(document, 'keydown', event => {
      if (event.key === 'Escape' && this.games.some(game => game.open)) {
        event.preventDefault();
        this.close(this.contains(document.activeElement));
      }
    });
    on(window, 'resize', () => this.fit());
    on(window, 'scroll', () => this.fit());
    on(window, 'pagehide', () => this.close());
    on(window, 'pageshow', () => this.close());
    on(document, 'shopify:block:select', event => {
      const details = event.target.closest('.fd-game-nav');
      if (details && this.contains(details)) this.open(details);
    });
    on(document, 'shopify:section:deselect', () => this.close());
  }
  clearTimers() {clearTimeout(this.openTimer);clearTimeout(this.closeTimer);}
  fit() {
    if (!this.games?.some(game => game.open)) return;
    const top = this.getBoundingClientRect().bottom;
    this.style.setProperty('--fd-menu-height', `${Math.max(180, innerHeight - Math.max(0, top) - 12)}px`);
  }
  open(details) {
    this.clearTimers();
    for (const game of this.games) {
      const expanded = game === details;
      if (game.open !== expanded) game.open = expanded;
      game.querySelector('summary').setAttribute('aria-expanded', String(expanded));
    }
    this.fit();
    this.dispatchEvent(new CustomEvent('fd:menu-open', {bubbles:true}));
  }
  close(returnFocus = false) {
    this.clearTimers();
    const active = this.games.find(game => game.open);
    this.games.forEach(game => {
      if (game.open) game.open = false;
      game.querySelector('summary').setAttribute('aria-expanded', 'false');
    });
    if (returnFocus) active?.querySelector('summary').focus({preventScroll:true});
  }
  disconnectedCallback() {this.clearTimers();clearTimeout(this.focusTimer);this.controller?.abort();}
}
if (!customElements.get('fd-shop-nav')) customElements.define('fd-shop-nav', FdShopNav);
